import { createFileRoute, Link } from "@tanstack/react-router";
import { LoanCategoryPage } from "@/components/laneguide/LoanCategoryPage";

export const Route = createFileRoute("/smslan")({
  head: () => ({
    meta: [
      { title: "SMS-lån – Jämför snabba mikrolån utan UC | Svensk Låneguide" },
      { name: "description", content: "Jämför SMS-lån och mikrolån utan UC. Utbetalning på minuter, ansök med BankID." },
      { property: "og:title", content: "SMS-lån – Jämför snabba mikrolån" },
      { property: "og:description", content: "SMS-lån utan UC med utbetalning på minuter." },
      { property: "og:type", content: "website" },
    ],
  }),
  component: () => (
    <LoanCategoryPage
      page="smslan"
      productLabel="SMS-lån"
      headingBefore="SMS-lån utan UC med utbetalning på"
      underlined="2 minuter"
      headingAfter=""
      subtitle={
        <>
          <Link to="/nyhet/$slug" params={{ slug: "sms-lan-guide" }} className="text-primary underline underline-offset-2">SMS-lån</Link> är mikrolån med korta löptider. Du får vanligtvis direkt utbetalning och pengarna på kontot inom 15 minuter, och du kan ansöka om lånet utan UC och med låga grundkrav (t.ex. utan inkomst eller skulder hos Kronofogden) – perfekt för akuta utgifter.
        </>
      }
      featuredTitleTemplate={(m) => `Toppval för SMS-lån i ${m}`}
    />
  ),
});
